import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import Cookies from 'js-cookie';

const EssayDetails = () => {
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const [revisionDetails, setRevisionDetails] = useState('');
  const [essay, setEssay] = useState(null); // State to hold the fetched essay details

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleFileChange = (e) => setFile(e.target.files[0]);
  const handleDetailsChange = (e) => setRevisionDetails(e.target.value);
  
  // Function to mark essay as completed
  const markCompleted = async () => {
    try {
      const response = await axios.put(`https://backend.writerswright.com/api/v1/student/markCompleted?Id=${Cookies.get('id')}&EssayId=${Cookies.get('essayId')}`);
      console.log(response.data); // Log response for debugging
      // Optionally, update state or fetch fresh data after marking completed
      setEssay({ ...essay, Status: 'Completed' }); // Assuming API updates status in the response
    } catch (error) {
      console.error('Error marking essay as completed:', error);
      alert('Failed to mark essay as completed. Please check the server logs.');
    }
  };

  const handleSubmit = async () => {
    try {
      // Construct form data for submitting the revision
      const formData = new FormData();
      formData.append('file', file);
      formData.append('revisionDetails', revisionDetails);

      // Example endpoint for submitting revision, adjust as per your API
      const response = await axios.post(`https://backend.writerswright.com/api/v1/student/addrivision?Id=${Cookies.get('essayId')}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log(response.data); // Log response for debugging
      handleClose();
      // Optionally update state or fetch fresh data after successful submission
    } catch (error) {
      console.error('Error submitting revision:', error);
      alert('Failed to submit revision. Please check the server logs.');
    }
  };

  useEffect(() => {
    const fetchEssayDetails = async () => {
      try {
        const response = await axios.get(`https://backend.writerswright.com/api/v1/student/getUploadedEssay?StudentId=${Cookies.get('id')}&EssayId=${Cookies.get('essayId')}`);
        console.log(response.data); // Log response for debugging
        setEssay(response.data.essays[0]); // Assuming there's only one essay fetched
      } catch (error) {
        console.error('Error fetching essay details:', error);
        alert('Failed to fetch essay details. Please check the server logs.');
      }
    };

    fetchEssayDetails();
  }, []);

  if (!essay) {
    return <Container>Loading...</Container>; // Placeholder for loading state
  }

  return (
    <Container>
      <h2 className='title'>Essay Details</h2>

      <div 
        style={{
          width: "100%",
          height: "100%",
          margin: "auto",
          borderRadius: "10px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
        }}
      >
        <Row style={{ padding: "5% 10%" }}>
          <Col lg={6} md={6} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Essay Name</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essay.Title}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Due Date</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{new Date(essay.deadline).toLocaleString()}</div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Status</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essay.Status}</div>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Document</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <a href={`https://backend.writerswright.com/${essay.document}`} style={{ color: "black", textDecoration: "underline" }}>View Document</a>
            </div>

            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Essay Details</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essay.details}</div>
          </Col>
        </Row>
      </div>

      <h2 className='title'>Grades & Feedback</h2>

      <div 
        style={{
          width: "100%",
          height: "100%",
          margin: "auto",
          borderRadius: "10px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
        }}
      >
        <Row style={{ padding: "5% 10%" }}>
          <Col lg={6} md={6} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Grade</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essay.Grade || 'Not graded yet'}</div>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Document</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <a href={`https://backend.writerswright.com/${essay.document}`} style={{ color: "black", textDecoration: "underline" }}>View Document</a>
            </div>
          </Col>

          <Col lg={12} md={12} sm={12}>
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ color: "var(--primary)" }}>Feedback</strong>
            </div>
            <div style={{ marginBottom: '20px' }}>{essay.Feedback || 'No feedback provided'}</div>
          </Col>
        </Row>
      </div>

      <Row>
        <Col className="d-flex justify-content-end align-items-end mb-3 mt-2">
          <button className='button-37' style={{ marginRight: "5px", marginTop: "5px" }} onClick={markCompleted}>Mark As Completed</button>
          <button className='button-37' style={{ marginTop: "5px" }} onClick={handleShow}>Add Revision</button>
        </Col>
      </Row>

      {/* Modal for adding revision */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Revision</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formFile">
              <Form.Label>Document</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formDetails">
              <Form.Label>Revision Details</Form.Label>
              <Form.Control as="textarea" rows={3} onChange={handleDetailsChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button className="button-37" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default EssayDetails;
